import React from 'react';
import PropTypes from 'prop-types';
import { Progress } from 'semantic-ui-react';
import { colorsModeUI } from '../modeUI';
import './index.css';

/**
 * UiProgress
 * Display the semantic component UiProgress
 * @param string id
 * @param string value: For use with total. Together, these will calculate the percent.
 *   Mutually excludes percent.
 * @param int total: For use with value. Together, these will calculate the percent.
 *   Mutually excludes percent.
 * @param string progress: A progress bar can contain a text value indicating current progress.
 * @param string label: Can be set to either to display progress as percent or ratio.
 * @param string mode
 */
export default class UiProgress extends React.PureComponent {
  render() {
    const { id, value, total, progress, label, mode } = this.props;
    const style = {};
    let styleFillingBar;
    if (mode !== null) {
      const colors = colorsModeUI(mode);
      style.backgroundColor = colors.PROGRESS_BAR_BACKGROUND_COLOR;
      style.color = colors.TEXT_COLOR;
      styleFillingBar = `.ui.progress.ui-progress .bar { background-color: ${colors.PROGRESS_BAR_FILL_COLOR} }`;
    }
    return (
      <div>
        {styleFillingBar && <style>{styleFillingBar}</style>}
        <Progress
          id={id}
          value={value}
          total={total}
          progress={progress}
          style={style}
          className={`${mode !== null && 'ui-progress'}`}
        >
          {label}
        </Progress>
      </div>
    );
  }
}

UiProgress.propTypes = {
  id: PropTypes.node,
  value: PropTypes.node,
  total: PropTypes.number,
  progress: PropTypes.string,
  label: PropTypes.string,
  mode: PropTypes.string,
};

UiProgress.defaultProps = {
  id: '',
  value: 0,
  total: 0,
  progress: 'value',
  label: '',
  mode: null,
};
